import styled from 'styled-components/native'

import { Box } from '../Box'

export const StyledOverlay = styled(Box)`
  background-color: ${({ theme }) => theme.colors.black50};
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1;
  justify-content: center;
  align-items: center;
`
